/**
 * Parse a chunk-buffered SSE stream into discrete events.
 * Returns { events: [{type, data}], rest: <remaining buffer> }
 */
export function parseSSEBuffer(buffer) {
  const rawEvents = buffer.split("\n\n");
  const rest = rawEvents.pop() || "";
  const events = rawEvents.map((raw) => {
    const lines = raw.split("\n");
    const isDone = lines.some((l) => l.startsWith("event: done"));
    const dataLines = lines.filter((l) => l.startsWith("data: ")).map((l) => l.slice(6));
    return {
      type: isDone ? "done" : "data",
      data: dataLines.join("\n"),
    };
  });
  return { events, rest };
}
